// AboutPage.jsx - Updated with separate components
import React from 'react';
import PageBanner from '../../../components/customer/pagebanner/PageBanner';
import StorySection from '../../../subscreens/customer/about/storysection/StorySection';
import StatsSection from '../../../subscreens/customer/about/statsSection/StatsSection';
import ValuesSection from '../../../subscreens/customer/about/valuessection/ValuesSection';
import TeamSection from '../../../subscreens/customer/about/teamsection/TeamSection';
import '../../../assets/css/customer/screens/AboutUs.css';
import MyNavbar from '../../../components/general/mynavbar/MyNavbar';
import Footer from '../../../components/general/footer/Footer';
import useScrollToTop from "../../../contexts/UseScrolltoTop";

const AboutPage = () => {
  useScrollToTop();
  return (
    <>
    <MyNavbar />
    
    <div className="about-page" >
      {/* Hero Section */}
      <PageBanner
        title="About Us"
        subtitle="Learn about our journey and passion for creating beautiful jewelry"
        breadcrumbs={[
          { label: 'About Us' }
        ]}
      />

      {/* Story Section */}
      <StorySection />

      {/* Stats Section */}
      <StatsSection />

      {/* Values Section */}
      <ValuesSection />

      {/* Team Section */}
      <TeamSection />
     
    </div>
    
    <Footer />
    </>
  );
};

export default AboutPage;